// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6u-0";
export var startPickingButton = "_6u-1";